export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const ADD_ERROR = 'add_error'
export const CLEAR_ERROR = 'clear_error_message'
